class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateColor();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateVariantData();
    }
  }
  setThumbsSlider(currentVariantData) {
    const sliderWrapper = document.querySelector(
      '.js-product-thumbs .swiper-wrapper',
    );
    sliderWrapper.innerHTML = '';

    const pattern = document.getElementById('product-thumbs-pattern-image');

    currentVariantData.thumbnail_images.forEach((media) => {
      const item = pattern.cloneNode(true);
      const content = item.content;
      content.querySelector('img').setAttribute('src', media.src);
      sliderWrapper.appendChild(content);
    });
  }

  setTopSlider(currentVariantData) {
    const sliderWrapper = document.querySelector(
      '.product__gallery .js-product-slider .swiper-wrapper',
    );
    const thumbsWrapper = document.querySelector(
      '.js-product-thumbs .swiper-wrapper',
    );

    if (!sliderWrapper || !thumbsWrapper) return;

    sliderWrapper.innerHTML = '';
    thumbsWrapper.innerHTML = '';

    // const patternImage = document.getElementById(
    //   'product-slider-pattern-image',
    // );
    // const patternVideo = document.getElementById(
    //   'product-slider-pattern-video',
    // );

    currentVariantData.images.forEach((media) => {
      const slideItem = document.createElement('li');
      slideItem.classList.add('product-slider__item', 'swiper-slide');

      if (media.type === 'video') {
        const videoContainer = document.createElement('div');
        videoContainer.classList.add('video', 'js-video', 'js-video-slider');

        const wrap = document.createElement('div');
        wrap.classList.add('video__wrap');

        const video = document.createElement('video');
        video.classList.add('video__player');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'none');
        if (media.poster) video.setAttribute('poster', media.poster);

        const source = document.createElement('source');
        source.setAttribute('src', media.src);
        source.setAttribute('type', 'video/mp4');
        video.appendChild(source);

        wrap.appendChild(video);

        // Mute button
        const muteBtn = document.createElement('button');
        muteBtn.className = 'video__mute mute js-video-mute';
        muteBtn.innerHTML = `
          <svg class="mute" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M13.5 4.06069C13.5 2.72433 11.8843 2.05508 10.9393 3.00003L6.43934 7.50003H4.50905C3.36772 7.50003 2.19106 8.16447 1.8493 9.40508C1.62147 10.2322 1.5 11.1025 1.5 12C1.5 12.8975 1.62147 13.7679 1.8493 14.595C2.19106 15.8356 3.36772 16.5 4.50905 16.5H6.43934L10.9393 21C11.8843 21.945 13.5 21.2757 13.5 19.9394V4.06069Z" fill="white"/>
            <path d="M18.5837 5.10567C18.8766 4.81278 19.3514 4.81278 19.6443 5.10567C23.452 8.91328 23.452 15.0866 19.6443 18.8943C19.3514 19.1871 18.8766 19.1871 18.5837 18.8943C18.2908 18.6014 18.2908 18.1265 18.5837 17.8336C21.8055 14.6118 21.8055 9.38816 18.5837 6.16633C18.2908 5.87344 18.2908 5.39856 18.5837 5.10567Z" fill="white"/>
            <path d="M15.9323 7.7574C16.2252 7.46451 16.7001 7.46451 16.993 7.7574C19.3361 10.1005 19.3361 13.8995 16.993 16.2427C16.7001 16.5356 16.2252 16.5356 15.9323 16.2427C15.6394 15.9498 15.6394 15.4749 15.9323 15.182C17.6897 13.4247 17.6897 10.5754 15.9323 8.81806C15.6394 8.52517 15.6394 8.0503 15.9323 7.7574Z" fill="white"/>
          </svg>
          <svg class="unmute" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M13.5 4.06069C13.5 2.72433 11.8843 2.05508 10.9393 3.00003L6.43934 7.50003H4.50905C3.36772 7.50003 2.19106 8.16447 1.8493 9.40508C1.62147 10.2322 1.5 11.1025 1.5 12C1.5 12.8975 1.62147 13.7679 1.8493 14.595C2.19106 15.8356 3.36772 16.5 4.50905 16.5H6.43934L10.9393 21C11.8843 21.945 13.5 21.2757 13.5 19.9394V4.06069Z" fill="white"/>
            <path d="M17.7803 9.21969C17.4874 8.92679 17.0126 8.92679 16.7197 9.21969C16.4268 9.51258 16.4268 9.98745 16.7197 10.2803L18.4393 12L16.7197 13.7197C16.4268 14.0126 16.4268 14.4875 16.7197 14.7803C17.0126 15.0732 17.4874 15.0732 17.7803 14.7803L19.5 13.0607L21.2197 14.7803C21.5126 15.0732 21.9874 15.0732 22.2803 14.7803C22.5732 14.4875 22.5732 14.0126 22.2803 13.7197L20.5607 12L22.2803 10.2803C22.5732 9.98745 22.5732 9.51258 22.2803 9.21969C21.9874 8.92679 21.5126 8.92679 21.2197 9.21969L19.5 10.9394L17.7803 9.21969Z" fill="white"/>
          </svg>
        `;
        wrap.appendChild(muteBtn);

        // Play/Pause button
        const controlBtn = document.createElement('button');
        controlBtn.className = 'video__button stop js-video-action';
        controlBtn.innerHTML = `
          <div class="video__icon">
            <svg
              class="video__play video__svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path fill-rule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"clip-rule="evenodd"/>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="video__stop video__svg"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5"/>
            </svg>
          </div>
        `;
        wrap.appendChild(controlBtn);

        videoContainer.appendChild(wrap);

        const slideItem = document.createElement('li');
        slideItem.classList.add('product-slider__item', 'swiper-slide');
        slideItem.appendChild(videoContainer);
        sliderWrapper.appendChild(slideItem);

        video.load();
        video
          .play()
          .catch((err) => console.warn('Safari autoplay blocked', err));
      } else {
        const img = document.createElement('img');
        img.src = media.src;
        img.alt = currentVariantData.title || 'Product Image';
        img.loading = 'lazy';

        slideItem.appendChild(img);
        sliderWrapper.appendChild(slideItem);
      }

      // sliderWrapper.appendChild(slideItem);

      const thumbItem = document.createElement('div');
      thumbItem.classList.add('swiper-slide');
      const thumbImg = document.createElement('img');
      thumbImg.src = media.poster || media.src;
      thumbImg.alt = 'Thumbnail';
      thumbImg.loading = 'lazy';
      thumbItem.appendChild(thumbImg);
      thumbsWrapper.appendChild(thumbItem);
    });

    // this.initVariantGallery('.js-product-slider', '.js-product-thumbs');
  }

  initVariantGallery(mainSelector, thumbsSelector) {
    const mainSliderEl = document.querySelector(mainSelector);
    const thumbsSliderEl = document.querySelector(thumbsSelector);

    if (!mainSliderEl || !thumbsSliderEl) return;

    if (mainSliderEl.swiper) mainSliderEl.swiper.destroy(true, true);
    if (thumbsSliderEl.swiper) thumbsSliderEl.swiper.destroy(true, true);

    let length = document.querySelectorAll(".js-product-thumbs .swiper-slide").length;
    length = length >= 7 ? 7 : length;

    const thumbsSlider = new Swiper(thumbsSliderEl, {
      direction: 'vertical',
      slidesPerView: 4,
      loop: true,
      breakpoints: {
        1024: {
          slidesPerView: length,
        },
      },
    });

    const mainSlider = new Swiper(mainSliderEl, {
      slidesPerView: 1,
      loop: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      thumbs: {
        swiper: thumbsSlider,
      },
      on: {
        slideChange() {
          const mutes = mainSliderEl.querySelectorAll(
            '.js-video-mute:not(.mute)',
          );
          mutes.forEach((btn) => btn.click());
        },
        afterInit() {
          const minContainer = document.querySelector(".js-set-height-slider");
          const height = document.querySelector(".js-product-slider").offsetHeight;
          minContainer.style.minHeight = height + 64 + "px";

          const videos = document.querySelectorAll(".product__gallery .js-video");
          if (!videos) return;
          videos.forEach((video) => {
            const videoPlayer = new VideoPlayer(video);
            videoPlayer.initVideo();
          });
        },
      },
      breakpoints: {
        990: {
          loop: false,
          autoHeight: false,
        },
      },
    });

    this.mainSlider = mainSlider;
    this.thumbsSlider = thumbsSlider;
  }

  updateVariantData() {
    if (!this.currentVariant) return;

    let variantTitle = this.currentVariant.title;
    let currentVariantData = window.product_variant_data.find(
      (v) => v.variant_name === variantTitle,
    );

    if (!currentVariantData) return;

    const features = document.querySelector(
      '.js-product-data-formula-features p',
    );
    const ingredients = document.querySelector(
      '.js-product-data-ingredients-list p',
    );
    if (currentVariantData.percent_natural && features) {
      features.innerHTML = currentVariantData.percent_natural;
    }
    if (currentVariantData.ingredients_list && ingredients) {
      ingredients.innerHTML = currentVariantData.ingredients_list;
    }

    this.setTopSlider(currentVariantData);
    this.setThumbsSlider(currentVariantData);
    this.initVariantGallery('.js-product-slider', '.js-product-thumbs');
    // this.setThumbsSlider(currentVariantData);
    // productSlider.sliderReInit();

    const currentSlider = document.querySelector(
      '.product__gallery .product-slider',
    );
    if (currentSlider) {
      currentSlider.querySelectorAll('video').forEach((v) => {
        v.muted = true;
      });
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    if (
      document.querySelector(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      )
    ) {
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      );
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`,
      );
      modalContent.prepend(newMediaModal);
    }
  }

  updateColor() {
    if (!this.currentVariant) return;

    const currentTitle = this.currentVariant.title;
    const currentVariantData = window.product_variant_data.find(
      (v) => v.variant_name === currentTitle,
    );

    const colorContainer = document.querySelector('.js-colorContainer');
    const shortDescriptionContainer = document.querySelector(
      '.js-shortDescriptionContainer',
    );

    if (colorContainer) {
      colorContainer.innerText = currentTitle;

      if (shortDescriptionContainer)
        shortDescriptionContainer.innerText =
          currentVariantData && currentVariantData.short_description
            ? currentVariantData.short_description
            : '';
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        let currentVariantData = window.product_variant_data.find(
          (v) => v.variant_id === this.currentVariant.id,
        );

        let buttonText = window.variantStrings.soldOut;
        if (currentVariantData && currentVariantData.badge_text) {
          buttonText = currentVariantData.badge_text;
        }

        this.toggleAddButton(!this.currentVariant.available, buttonText);
      });
    let affirmElement = document.querySelector('.affirm-as-low-as');
    if (affirmElement && affirm) {
      affirmElement.setAttribute('data-amount', this.currentVariant.price);
      affirm.ui.ready(function () {
        affirm.ui.refresh();
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
